import SiteShell from "../components/SiteShell";

const photos = [
  {
    src: "/FinnCube.jpeg",
    title: "FinnCube Kiosk",
    text: "A closer look at the kiosk experience built for fast, assisted loan journeys.",
  },
  {
    src: "/finnCube2.jpeg",
    title: "Kiosk Interface",
    text: "Designed for simple, guided onboarding from eligibility to digital consent.",
  },
  {
    src: "/kiosk-media.png",
    title: "Retail Deployment",
    text: "A physical credit access point ready for high-footfall partner locations.",
  },
  {
    src: "/retail_kiosk_environment_1772861342202.png",
    title: "Customer Environment",
    text: "Built to make digital finance feel accessible, clear, and dependable.",
  },
  {
    src: "/HomePage.png",
    title: "Product Showcase",
    text: "The FinnCube experience brings speed, security, and trust together.",
  },
  {
    src: "/user_verification_close_up_1772861182149.png",
    title: "Secure Verification",
    text: "Every step is structured around controlled, banking-grade verification.",
  },
];

const videos = [
  {
    src: "/kiosk.mp4",
    title: "Kiosk in Action",
    text: "Watch the assisted loan journey flow through the FinnCube kiosk.",
  },
  {
    src: "/finncube demo.mp4",
    title: "FinnCube Demo",
    text: "A quick walkthrough of the kiosk-led customer experience.",
  },
  {
    src: "/video.mp4",
    title: "Product Video",
    text: "A visual overview of the FinnCube instant loan kiosk.",
  },
];

function Media() {
  return (
    <SiteShell
      route="media"
      heroTag="Media Gallery"
      heroTitle="See how FinnCube works"
      heroText="Explore FinnCube's kiosk experience through product photos, deployment visuals, and demo videos."
      heroImage="/kiosk.mp4"
      heroHighlights={[
        { label: "Gallery", value: "Photos" },
        { label: "Demo", value: "Videos" },
        { label: "Experience", value: "Kiosk Flow" },
        { label: "Built For", value: "Salaried Users" },
      ]}
    >
      <section className="mx-auto max-w-[1280px] px-4 py-14 sm:px-6 sm:py-16 md:px-10 md:py-20">
        <div className="flex flex-col gap-4 text-center md:text-left">
          <p className="text-xs font-black uppercase tracking-[0.2em] text-[#e37921] sm:text-[15px] sm:tracking-[0.3em]">
            Photo Gallery
          </p>
          <h2 className="text-3xl font-extrabold tracking-tight text-[#0a2c4f] sm:text-4xl md:text-5xl">
            Kiosk Moments and Product Views
          </h2>
          <p className="max-w-3xl text-sm leading-relaxed text-slate-500 sm:text-base md:text-lg">
            A curated look at the FinnCube kiosk, customer journey visuals, and
            real-world deployment environment.
          </p>
        </div>

        <div className="mt-10 grid gap-6 md:grid-cols-2 xl:grid-cols-3">
          {photos.map((photo) => (
            <article
              key={photo.title}
              className="group overflow-hidden rounded-[28px] border border-slate-100 bg-white p-2 shadow-xl transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_36px_70px_-24px_rgba(10,44,79,0.24)]"
            >
              <div className="h-64 overflow-hidden rounded-[22px] bg-slate-100 sm:h-72">
                <img
                  src={photo.src}
                  alt={photo.title}
                  className="h-full w-full object-cover transition duration-700 group-hover:scale-105"
                />
              </div>
              <div className="p-5">
                <h3 className="text-xl font-extrabold tracking-tight text-[#0a2c4f]">
                  {photo.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-500">
                  {photo.text}
                </p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="bg-[#071f36] py-14 text-white sm:py-16 md:py-20">
        <div className="mx-auto max-w-[1280px] px-4 sm:px-6 md:px-10">
          <div className="flex flex-col gap-4 text-center md:text-left">
            <p className="text-xs font-black uppercase tracking-[0.2em] text-sky-300 sm:text-[15px] sm:tracking-[0.3em]">
              Video Gallery
            </p>
            <h2 className="text-3xl font-extrabold tracking-tight sm:text-4xl md:text-5xl">
              See the Kiosk Experience in Motion
            </h2>
            <p className="max-w-3xl text-sm leading-relaxed text-sky-100/75 sm:text-base md:text-lg">
              Product clips and demo videos showing the kiosk journey, interface,
              and assisted credit experience.
            </p>
          </div>

          <div className="mt-10 grid gap-7 lg:grid-cols-3">
            {videos.map((video) => (
              <article
                key={video.title}
                className="overflow-hidden rounded-[28px] border border-white/10 bg-white/[0.04] p-2 shadow-2xl"
              >
                <div className="overflow-hidden rounded-[22px] bg-black">
                  <video
                    className="pointer-events-none aspect-video w-full object-cover"
                    autoPlay
                    muted
                    loop
                    preload="auto"
                    playsInline
                    disablePictureInPicture
                    controlsList="nodownload nofullscreen noremoteplayback"
                  >
                    <source src={video.src} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
                <div className="p-5">
                  <h3 className="text-xl font-extrabold tracking-tight text-white">
                    {video.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-sky-100/70">
                    {video.text}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </SiteShell>
  );
}

export default Media;
